import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const QUERY = gql`
  query PreviewUpgradeCost(
    $customerId: ID!
    $tier: String
    $plan: String
    $billingCycle: BillingCyclePeriod
    $promotionCode: String
  ) {
    previewUpgradeCost(
      customerId: $customerId
      tier: $tier
      plan: $plan
      billingCycle: $billingCycle
      promotionCode: $promotionCode
    ) {
      dueToday
      balanceAfterUpgrade
      currentBalance
    }
  }
`;

export const previewUpgradeCost = ({ customerId, tier, plan, billingCycle, promotionCode }) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      tier,
      plan,
      billingCycle,
      promotionCode,
    },
  }).then(({ data }) => getSingleProp(data));
